import React from 'react';

interface Payload { total_usd?: number; month_usd?: number; currency?: string; }

export default function CostCounter({ data }: { data: unknown }) {
  const d   = (data ?? {}) as Payload;
  const cur = d.currency ?? '$';
  const wrapSt:  React.CSSProperties = { height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' };
  const labelSt: React.CSSProperties = { fontSize: 12, color: 'var(--tg-theme-hint-color)', margin: 0 };
  const numSt:   React.CSSProperties = { fontSize: 28, fontWeight: 700, lineHeight: 1, margin: 0, color: 'var(--tg-theme-accent-text-color)' };
  const subSt:   React.CSSProperties = { fontSize: 12, color: 'var(--tg-theme-hint-color)', margin: '4px 0 0' };
  const totalSt: React.CSSProperties = { fontSize: 11, color: 'var(--tg-theme-hint-color)', margin: 0, opacity: 0.5 };
  return (
    <div style={wrapSt}>
      <p style={labelSt}>Расходы</p>
      <div>
        <p style={numSt}>{cur}{d.month_usd != null ? d.month_usd.toFixed(4) : '—'}</p>
        <p style={subSt}>за месяц</p>
      </div>
      {d.total_usd != null && <p style={totalSt}>итого: {cur}{d.total_usd.toFixed(4)}</p>}
    </div>
  );
}
